import { useState, useEffect } from "react";
import { Box, Paper, Typography, Button, Link } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { useLocation } from "react-router-dom";

const RUNTIME_EMBED_ROUTE_REGEX = /^\/app\/[^/]+\/(?:widget|display)(?:\/|$)/;
import dico from "src/shared/util/src/language/dico";

/**
 * Informational banner about anonymous analytics on regular web pages.
 * No consent required (GDPR-compliant anonymous data).
 */
export function AnalyticsBanner() {
  const myDico = dico();
  const ab = myDico.analyticsBanner;
  const [visible, setVisible] = useState(false);
  const location = useLocation();
  const isRuntimeEmbedRoute = RUNTIME_EMBED_ROUTE_REGEX.test(location.pathname);

  // Check if user has already acknowledged the banner
  useEffect(() => {
    const acknowledged = localStorage.getItem("analytics_banner_acknowledged");
    if (!acknowledged) {
      setVisible(true);
    }
  }, []);
  // Handle acknowledgment
  const handleAcknowledge = () => {
    localStorage.setItem("analytics_banner_acknowledged", "true");
    setVisible(false);
  };
  if (!visible || isRuntimeEmbedRoute) return null;
  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        padding: 2,
      }}
    >
      <Paper
        elevation={6}
        sx={{
          padding: 2,
          maxWidth: 800,
          margin: "0 auto",
          display: "flex",
          alignItems: "center",
          gap: 2,
        }}
      >
        <InfoIcon color="primary" />
        <Box sx={{ flex: 1 }}>
          <Typography variant="body2" sx={{ marginBottom: 0.5 }}>
            {ab.message}
          </Typography>
          <Link
            href="/privacy"
            variant="body2"
            sx={{ textDecoration: "underline" }}
          >
            {ab.privacyLink}
          </Link>
        </Box>
        <Button variant="contained" onClick={handleAcknowledge} size="small">
          {ab.acknowledge}
        </Button>
      </Paper>
    </Box>
  );
}
